export default __webpack_public_path__ + "static/media/egg-6.ff418a88.png";